import { RootState } from '../../../store';

export const getTrainerSelector = (state: RootState) => state.trainer.trainer;
export const getLoadingTrainerSelector = (state: RootState) => state.trainer.isLoading;
export const getTrainerErrorsSelector = (state: RootState) => state.trainer.errors;
export const getAllCoursesSelector = (state: RootState) => state.trainer.coursesForm;
export const getCoursesLoadMoreSelector = (state: RootState) => state.trainer.loadMore;
